import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'compact';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
const base = 'group inline-flex items-center justify-center gap-3 rounded-xl text-center font-sans font-bold uppercase leading-tight tracking-wide transition-[transform,background-color,box-shadow,color,border-color] duration-150 ease-calm focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-forest-200 active:translate-y-px';
const sizes: Record<NonNullable<CtaButtonProps['size']>, string> = {
  sm: 'px-4 py-2.5 text-xs',
  md: 'px-6 py-3.5 text-sm',
  lg: 'px-8 py-4 text-base md:text-lg',
  xl: 'px-8 py-5 text-base md:text-xl'
};
const variants: Record<NonNullable<CtaButtonProps['variant']>, string> = {
  primary: 'bg-forest-600 text-white shadow-cta hover:bg-forest-500',
  secondary: 'border-2 border-forest-600 bg-transparent text-forest-600 hover:bg-forest-600 hover:text-white',
  compact: 'bg-forest-600 text-white hover:bg-forest-500'
};
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#inversion',
  className = ''
}: CtaButtonProps) {
  return <a href={href} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-33" data-mp="3ezx9nj469tw8">
      <span data-id="element-34" data-mp="3jy8m81luqii5">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-calm group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-35" data-mp="3ow09ujfgrigj" />
    </a>;
}